import { AloftPriceJSON } from '@aloft/shared-objects';
import { createAction } from '@reduxjs/toolkit';

export const setOpinionOfSiteValue = createAction<AloftPriceJSON>(
  'propertyData/setOpinionOfSiteValue',
);
